import { Alert, AlertTitle, Box } from "@mui/material";

export const NoPhoneNumbersAlert = () => {
  return (
    <Box sx={{ pt: 1 }}>
      <Alert severity="error" data-test="no-phone-numbers-alert">
        <AlertTitle>No Phone Numbers Provided</AlertTitle>
        Unable to send text — <strong>candidate has no phone numbers</strong>
      </Alert>
    </Box>
  );
};

export const NoValidPhoneNumbersAlert = ({ message }: { message?: string }) => {
  return (
    <Box sx={{ pt: 1 }}>
      <Alert severity="error" data-test="no-valid-phone-numbers-alert">
        <AlertTitle>No Valid Phone Numbers Provided</AlertTitle>
        Unable to send text — <strong>{message ? message : "candidate has no valid phone numbers"}</strong>
      </Alert>
    </Box>
  );
};

export const UnsubscribedAlert = () => {
  return (
    <Box sx={{ pt: 1, mb: 2 }}>
      <Alert severity="error" data-test="unsubscribed-alert">
        <AlertTitle>Candidate Has Unsubscribed from Emails</AlertTitle>
        Unable to send email — <strong>candidate has unsubscribed</strong>
      </Alert>
    </Box>
  );
};

export const NoEmailAlert = () => {
  return (
    <Box sx={{ pt: 1, mb: 2 }}>
      <Alert severity="error" data-test="no-emails-alert">
        <AlertTitle>Candidate Has No Email Addresses</AlertTitle>
        Unable to send email — <strong>candidate has no email addresses</strong>
      </Alert>
    </Box>
  );
};

export const StopComplianceAlert = () => {
  return (
    <Box sx={{ pt: 1 }}>
      <Alert severity="error" data-test="stop-compliance-alert">
        <AlertTitle>STOP COMPLIANCE</AlertTitle>
        Unable to send text — <strong>candidate has replied with a stop phrase</strong>
      </Alert>
    </Box>
  );
};

export const NoMessagesAlert = () => {
  return (
    <Box>
      <Alert severity="warning" data-test="no-messages-alert">
        <AlertTitle>No Messages</AlertTitle>
        The candidate selected — <strong>has no message history!</strong>
      </Alert>
    </Box>
  );
};
